import React from 'react';
const facts = [{
  value: '139',
  label: 'Breath Cards'
}, {
  value: '38',
  label: 'Printable worksheets'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '~300',
  label: 'Landscape pages'
}];

// Bandas de bloque, como en los tomos
const accents = ['before:bg-sage', 'before:bg-teal', 'before:bg-terra', 'before:bg-ochre'];
export function SocialProofBar() {
  return <section className="w-full bg-sand" data-id="element-233" data-mp="32jmni5g7jbjj">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:py-12" data-id="element-234" data-mp="32ibnmgpvunxp">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-sand-dark bg-sand-dark sm:grid-cols-4" data-id="element-235" data-mp="2xjs0we3gt84a">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-cream px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-236" data-mp="2ojbx13it7yyw" data-mpi={i}>
              <div className="font-display text-3xl leading-none text-sage sm:text-4xl" data-id="element-237" data-mp="1d3naueddr3z5">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-238" data-mp="18oubx4545j12">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}